import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "mx-auto d-flex mb-6",
  style: {"width":"85%"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center bg-grey-darken-3 text-white p-3 rounded",
  style: {"width":"70px"}
}
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = { class: "w-100 d-flex flex-column align-items-center" }
const _hoisted_5 = { class: "w-100 bg-light rounded d-flex flex-column position-relative" }
const _hoisted_6 = { class: "w-100 mt-1" }
const _hoisted_7 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_8 = {
  style: {"width":"99%"},
  class: "mx-auto"
}

import ECharts from '@/components/Every24HoursReportPreviewParts/chart/ECharts.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartContent',
  props: {
    modelValue: {},
    type: {},
    scaleMinMax: {},
    chartData: {},
    displayData: {},
    xLabels: {},
    verticalLines: {},
    options: {},
    chartLabels: {},
    chartHeight: {},
    changeMinMax: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t(props.chartLabels[0])) + " ", 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t(props.chartLabels[1])), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ECharts, {
          ref: "eCharts",
          type: props.type,
          chartData: props.chartData,
          displayData: props.displayData,
          scaleMinMax: props.scaleMinMax,
          options: props.options,
          verticalLines: props.verticalLines,
          chartHeight: props.chartHeight
        }, null, 8, ["type", "chartData", "displayData", "scaleMinMax", "options", "verticalLines", "chartHeight"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.xLabels, (label, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              style: {"font-size":"12px"},
              class: "x-label mb-0"
            }, _toDisplayString(label), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_slider, {
            modelValue: modelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
            step: "1",
            "track-fill-color": "#2C7CFF",
            "track-color": "#DDDDDD",
            "thumb-color": "#2C7CFF",
            onEnd: _cache[1] || (_cache[1] = ($event: any) => (props.changeMinMax()))
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})